module.exports = __webpack_public_path__ + "static/assets/3e83d9d800459175308f0b45b117af16.png";